import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import {
  GetCommunicationsContentResponse,
  GetCommunicationsContentResponseV2,
  GetCommunicationsDetailRequest
} from "./interfaces/get-communications-details";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getCommunicationsDetails(
  data: GetCommunicationsDetailRequest,
  env: Environment
): Promise<string | ResponseError> {
  const url = `${getBaseUrl(env)}CxM/message-details/${
    data.messageDetailId
  }?consumer=${data.ccID}&ConsumerRecordSystem=${data.consumerRecordSystem}`;

  const header = await getHeader();

  try {
    const response =
      await fetchWrapper.getAsync<GetCommunicationsContentResponse>(
        url,
        header
      );
    if (response && response.data && !response.hasError) {
      return response.data.content ?? "";
    } else {
      const error: ResponseError = {
        isError: true,
        statusCode: response.statusCode,
        errorResult: response.error,
        url
      };
      return error;
    }
  } catch (error: unknown) {
    const typedError = error as { statusCode?: number; message?: string };
    const responseError: ResponseError = {
      isError: true,
      statusCode: typedError.statusCode || 500,
      errorResult: new Error(typedError.message || "Internal Server Error"),
      url
    };
    return responseError;
  }
}

export async function getCommunicationsDetailsV2(
  data: GetCommunicationsDetailRequest,
  env: Environment
): Promise<string | ResponseError> {
  const url = `${getBaseUrl(env)}CxM/message-details/${
    data.messageDetailId
  }?consumerId=${data.ccID}&ConsumerRecordSystem=${data.consumerRecordSystem}`;

  const header = await getHeader(2);

  try {
    const response =
      await fetchWrapper.getAsync<GetCommunicationsContentResponseV2>(
        url,
        header
      );

    if (response && response.data && !response.hasError) {
      return response.data.content ?? "";
    } else {
      const error: ResponseError = {
        isError: true,
        statusCode: response.statusCode,
        errorResult: response.error,
        url
      };
      return error;
    }
  } catch (error: unknown) {
    const typedError = error as { statusCode?: number; message?: string };
    const responseError: ResponseError = {
      isError: true,
      statusCode: typedError.statusCode || 500,
      errorResult: new Error(typedError.message || "Internal Server Error"),
      url
    };
    return responseError;
  }
}
